import { takeEvery, all } from 'redux-saga/effects'

import switchTab from './switchTab'
import fetcher from './fetcher'
import { actions } from '../constants'

export default function* rootSaga() {
  yield all([takeEvery(actions.SWITCH_TAB, switchTab), takeEvery(actions.data.FETCH, fetcher)])
}
